export const userConstants = {
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  GETALL_REQUEST: 'USERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'USERS_GETALL_FAILURE',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',

  SET_PROFILE: 'SET_CANDIDATE_PROFILE',

  UPDATE_SUCCESS_RECOVER: 'UPDATE_SUCCESS_RECOVER',
  UPDATE_SUCCESS_RECOVER_PASSWORD: 'UPDATE_SUCCESS_RECOVER_PASSWORD',

  IS_LOADING: 'LOGIN_IS_LOADING',
  IS_LOADING2: 'LOGIN_IS_LOADING2',

  IS_LOADING_CANDIDATE_SCHOOLS: 'IS_LOADING_CANDIDATE_SCHOOLS',
  IS_LOADING_CANDIDATE_LANGS: 'IS_LOADING_CANDIDATE_LANGS',

  SET_CANDIDATE_JOBS: 'SET_CANDIDATE_JOBS',
  SET_EXPECTED_JOBS: 'SET_EXPECTED_JOBS',
  SET_CANDIDATE_JOB_PROFILE: 'SET_CANDIDATE_JOB_PROFILE',

  SET_CANDIDATE_LANGUAGES: 'SET_CANDIDATE_LANGUAGES',
  SET_CANDIDATE_SCHOOLS: 'SET_CANDIDATE_SCHOOLS',
};
